<template>
    <div>
        <yetkidialog ref="yetkidialog"></yetkidialog>
        <hatadialog ref="hatadialog"></hatadialog>
        <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
        <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>
    
      
    
        <v-card height="100%" color="grey lighten-5" flat>
            <v-form>
                <v-layout row wrap>
                    <v-flex xs12 sm12>
                        <v-toolbar class="baslik" size="120px" dark color="info">
                            <v-toolbar-title>Master Paket </v-toolbar-title>
                            <v-spacer></v-spacer>
    
    
                              
                            <v-tooltip bottom>
                                <v-btn  slot="activator"  @click="kaydet()"  flat> <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t('save_button')}}</span>
                                    </span>
                                    <v-icon right dark>add_box</v-icon>
                                </v-btn>
    
                                
                                <span >{{ this.$t('Save') }}</span>
                            </v-tooltip>
    
                            <v-menu bottom="">
                                <v-btn slot="activator" dark icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
    
                                <v-list>
                                    <a target="_self" v-bind:href="'#/pakettur/masterpaket/'">
    
                                        <v-list-tile>
                                            <v-list-tile-title>{{$t('cancel_button')}}</v-list-tile-title>
                                        </v-list-tile>
                                    </a>
                                </v-list>
                                
                            </v-menu>
    
                        </v-toolbar>
                    </v-flex>
    
                    <v-tabs style="width:100%;" dark="" v-model="active" color="blue darken-3" slot="extension" slider->
                        <v-tabs-slider></v-tabs-slider>
                        <v-tab href='#0'>
                            {{$t("tab_general")}}
                        </v-tab>
                        <v-tab-item :id="'0'" style="width:100%; height:500px;">
                            <v-layout row="" wrap="">
                                <v-flex pa-1 xs12 sm6 md6>
                                    <v-card class="white--text">
                                        <v-card flat="">
                                            <v-card-actions>
                                                <v-layout row wrap>
                                                    <v-flex xs9 md3 sm9>
                                                    <v-text-field label="Kod"  maxlength="15"  hide-details="" v-model="turKodu"  required>
                                                     
                                                    </v-text-field>

                                                </v-flex>
                                                <v-flex xs9 md7 sm8>
                                                    <v-text-field label="Adı"  maxlength="15"  hide-details="" v-model="turAdi"  required>
                                                     
                                                    </v-text-field>

                                                </v-flex>
                                                <v-flex xs9 md2 sm8>
                                                    <v-checkbox label="Aktif" v-model="turAktif"></v-checkbox>

                                                </v-flex>
                                                <v-flex xs9 md6 sm12>
                                                        <v-select
                            label="Kategori"
                            item-text="Aciklama"
                            item-value="Id"
                            :items="kategoriler"
                            v-model="turKategoriID"
                          ></v-select>

                                                </v-flex>
                                                <v-flex xs9 md6 sm12>
                                                    <v-select
                            label="Ürün Grubu"
                            item-text="Aciklama"
                            item-value="Id"
                            :items="urungruplari"
                             v-model="turUrunGrupID"
                          ></v-select>

                                                </v-flex>
                                                <v-flex xs9 md4 sm8>
                                                    <v-text-field label="Gündüz"  maxlength="15"  hide-details="" v-model="turGunduz" required>
                                                     
                                                    </v-text-field>

                                                </v-flex>
                                                <v-flex xs9 md4 sm8>
                                                    <v-text-field label="Gece"  maxlength="15"  hide-details="" v-model="turGece"  required>
                                                     
                                                    </v-text-field>

                                                </v-flex>
                                                <v-flex xs9 md4 sm8>
                                                    <v-text-field label="Kontenjan"  maxlength="15"  hide-details="" v-model="turKontenjan"  required>
                                                     
                                                    </v-text-field>

                                                </v-flex>
                                                </v-layout>
                                               
                                            </v-card-actions>
                                        </v-card>
                                    </v-card>
                                  
                                </v-flex>
                                <v-flex pa-1 xs12 sm6 md6>
                                    <v-card class="white--text">
                                        <v-card flat="">
                                            <v-card-actions>
                                                <v-layout row wrap>
                                                    <v-flex xs9 md12 sm12>
                                                        <v-select
                            label="Başlangıç Noktası"
                            item-text="KategoriAdi"
                            item-value="Id"
                            items="kategoriler"
                            
                          ></v-select>

                                                </v-flex>
                                                <v-flex xs9 md6 sm12>
                                                    <v-select
                            label="Varış Parkur"
                            item-text="KategoriAdi"
                            item-value="Id"
                            items="kategoriler"
                            
                          ></v-select></v-flex>
                          <v-flex xs9 md6 sm12>
                                                    <v-select
                            label="Dönüş Parkur"
                            item-text="KategoriAdi"
                            item-value="Id"
                            items="kategoriler"
                            
                          ></v-select>
                                                </v-flex>
                                                <v-flex xs9 md12 sm12>
                                                    <v-textarea
                             v-model="turNotlar"
                              :label="$t('Notes')"
                            ></v-textarea>
                                                </v-flex>
                                                </v-layout>
    
                                            </v-card-actions>
                                        </v-card>
                                    </v-card>
                                </v-flex>
                               
                            </v-layout>
                           
                          
                        </v-tab-item>
    
                        <v-tab href='#1' ripple>
                            {{ 'Resimler' }}
                        </v-tab>
    
                        <v-tab-item :id="'1'" style="width:100%; height:100%;">
                            <v-layout row wrap>
                                <v-container fluid>
            <v-card color="grey lighten-5">
              <v-layout row wrap>
                <v-flex xs12 sm6 md2>
                  <v-layout align-center justify-start row fill-height>
                    <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data"
                     lazy-validation>
                      <input hidden type="file" id="files" ref="files" multiple  />
                    </v-form>
                    <v-btn :loading="false" :disabled="false" color="info" dark >
                      <v-icon color="white" left>attach_file</v-icon> {{ 'Eklenecek Resim Dosyası Seçin' }}
                    </v-btn>

                    <div v-show="load2">
                      <v-btn small="" fab @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                       color="info" dark>
                        <v-icon>redo</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>{{$t('Transfer-Selected')}}</span>
                      </v-tooltip>
                    </div>



                  

                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md4>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-alert :value="true" :color="alertcolor" icon="check_circle" outline>
                  
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>
                          

                            </v-layout>
                            <v-layout row="" wrap="">
                            <v-container fluid>

                                <v-layout row="" wrap="">
                           
                           
                                <v-flex pa-1 xs12 sm6 md3>
                                    <v-card >
                                        <v-card-text >
                                            <v-img 
              class="bg-grey-lighten-2 w-100"
            
              src="https://picsum.photos/350/165?random"
            ></v-img>
                                        </v-card-text>
         
                                        <v-card-action >
                                            <v-spacer></v-spacer>
                <v-btn flat icon color="">
              <v-icon>delete</v-icon>
            </v-btn>
            <v-btn flat icon color="">
              <v-icon>star</v-icon>
            </v-btn>
            </v-card-action>
          </v-card>
    
                                </v-flex>
                                <v-flex pa-1 xs12 sm6 md3>
                                    <v-card>
                                        <v-card-text>
                                            <v-img
              class="bg-grey-lighten-2  w-100"
              
              src="https://picsum.photos/350/165?random"
            ></v-img>
                                        </v-card-text>
         
                                        <v-card-action >
                                            <v-spacer></v-spacer>
                <v-btn flat icon color="">
              <v-icon>delete</v-icon>
            </v-btn>
            <v-btn flat icon color="">
              <v-icon>star</v-icon>
            </v-btn>
            </v-card-action>
          </v-card>
    
                                </v-flex>
                                <v-flex pa-1 xs12 sm6 md3>
                                    <v-card>
                                        <v-card-text>
                                            <v-img
                                            
              class="bg-grey-lighten-2  w-100"
             
              src="https://picsum.photos/350/165?random"
            ></v-img>
                                        </v-card-text>
         
            <v-card-action class="text-h6">
                <space></space>
                <v-btn flat icon color="">
              <v-icon>delete</v-icon>
            </v-btn>
            <v-btn flat icon color="">
              <v-icon>star</v-icon>
            </v-btn>
            </v-card-action>
          </v-card>
    
                                </v-flex>
                                <v-flex pa-1 xs12 sm6 md3>
                                    <v-card>
                                        <v-card-text>
                                            <v-img
                                            
              class="bg-grey-lighten-2  w-100"
              
              src="https://picsum.photos/350/165?random"
            ></v-img>
                                        </v-card-text>
         
            <v-card-action class="text-h6">
                <space></space>
                <v-btn flat icon color="">
              <v-icon>delete</v-icon>
            </v-btn>
            <v-btn flat icon color="blue">
              <v-icon>star</v-icon>
            </v-btn>
            </v-card-action>
          </v-card>
    
                                </v-flex>
                            </v-layout>
                            </v-container>
                            </v-layout>
                     
                        </v-tab-item>
    
                        <v-tab href='#2' ripple>
                            {{ $t('Program') }}
                        </v-tab>
    
                        <v-tab-item :id="'2'">
                            <v-layout row="" wrap="">
                                <v-flex pa-2 xs12 sm12 md4>
                                    <v-card>
                                        <v-card-text>
                                            <v-select
                            label="Fiyat Grup"
                            item-text="KategoriAdi"
                            item-value="Id"
                            items="kategoriler"
                            
                          ></v-select>
                          <v-select
                            label="Alt Grup"
                            item-text="KategoriAdi"
                            item-value="Id"
                            items="kategoriler"
                            
                          ></v-select>
                          <v-select
                            label="Tarih"
                            item-text="KategoriAdi"
                            item-value="Id"
                            items="kategoriler"
                            
                          ></v-select>
                          <v-select
                            label="İş"
                            item-text="KategoriAdi"
                            item-value="Id"
                            items="kategoriler"
                            
                          ></v-select>
                                        </v-card-text>
                                        <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn slot="activator" flat>
                <v-icon right color="info">add_box</v-icon>
                <span class="hidden-sm-and-down">
                  <span class="hidden-sm-and-down">Ekle</span>
                </span>
              </v-btn>

            
            </v-card-actions>

                                    </v-card>
     
                                </v-flex>

                                <v-flex pa-2 xs12 sm12 md8>
                                    <v-card>
                                        <v-container fluid grid-list-md>
    <v-data-iterator
      :items="items"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      content-tag="v-layout"
      row
      wrap
    >
      <template v-slot:item="props">
        <v-flex
          xs12
          sm6
          md4
          lg3
        >
          <v-card>
            <v-card-title><h4>{{ props.item.name }}</h4></v-card-title>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-tile>
                
                <v-list-tile-content class="align-end">{{ props.item.calories }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
               
                <v-list-tile-content class="align-end">{{ props.item.fat }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
               
                <v-list-tile-content class="align-end">{{ props.item.carbs }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
              
                <v-list-tile-content class="align-end">{{ props.item.protein }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
               
                <v-list-tile-content class="align-end">{{ props.item.sodium }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                
                <v-list-tile-content class="align-end">{{ props.item.calcium }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
              
                <v-list-tile-content class="align-end">{{ props.item.iron }}</v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </template>
    </v-data-iterator>
  </v-container>

                                    </v-card>
                                </v-flex>
                          
                            </v-layout>
                        </v-tab-item>
    
                        <v-tab href='#3' ripple>
                            {{$t('Price')}}
                        </v-tab>
    
                        <v-tab-item :id="'3'">
    
                            <v-layout row="" wrap>
                                
                                <v-flex  xs12
          sm6
          md4
          lg3 pa-2>
          <v-card>
                                    <v-card-title class="text-subtitle-2">
                                          Fiyat Grupları <v-spacer></v-spacer>

<v-btn slot="activator" flat>
  <v-icon right color="info">add_box</v-icon>
  <span class="hidden-sm-and-down">
    <span class="hidden-sm-and-down">Ekle</span>
  </span>
</v-btn>
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text>
                                        <v-data-table :headers="headersfiyatgrup"  :loading="progress" :items="itemsfiyatgrup"
        :search="search3"  :hide-default-footer="true">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr  item>
            <td class="text-xs-left">{{ props.item.GrupAdi }}</td>
            <td class="justify-end align-center full-heigth layout px-0">
              <v-btn  icon small flat>
                <v-icon color="info">search</v-icon>
              </v-btn>
              <v-btn  icon small flat>
                <v-icon color="warning">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
       
      </v-data-table>
                                    </v-card-text>
                                </v-card>
                                </v-flex>
                                <v-flex  xs12
          sm6
          md8
          lg9 pa-2>
          <v-card>
            <v-card-title>
                                        Fiyatlar
                                        <v-spacer></v-spacer>

<v-btn slot="activator" flat>
  <v-icon righ color="info"t>add_box</v-icon>
  <span class="hidden-sm-and-down">
    <span class="hidden-sm-and-down">Ekle</span>
  </span>
</v-btn>
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text>
                                        <v-data-table :headers="headersfiyatalt"  :loading="progress" :items="itemsfiyatalt"
        :search="search3"  :hide-default-footer="true">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr  item>
            <td class="text-xs-left">{{ props.item.AltSinif }}</td>
            <td class="text-xs-left">{{ props.item.Hotel }}</td>
            <td class="text-xs-left">{{ props.item.HotelKategori }}</td>
            <td class="text-xs-left">{{ props.item.Pax }}</td>
            <td class="text-xs-left">{{ props.item.Yfiyat }}</td>
            <td class="text-xs-left">{{ props.item.Cfiyat }}</td>
            <td class="text-xs-left">{{ props.item.PB }}</td>
            <td class="text-xs-left">{{ props.item.Aktif }}</td>
            <td class="justify-end align-center full-heigth layout px-0">
              <v-btn  icon small flat>
                <v-icon color="info">search</v-icon>
              </v-btn>
              <v-btn  icon small flat>
                <v-icon color="warning">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
       
      </v-data-table>
                                    </v-card-text>
                                </v-card>
                                </v-flex>
                            </v-layout>
                        </v-tab-item>
    
                      
    
                    </v-tabs>
    
                    
                
    
    
                 
    
                </v-layout>
            </v-form>
    
        </v-card>
    </div>
    </template>
    
    <script>
    import auth from '../../../api/auth'
    import parainput from '../customcomp/parainput'
    import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
    import tarihim from "@/components/app/customcomp/tarihim.vue"
    import tool from "../coper/tools";
    import helpers from "@/components/app/customcomp/helpers.js"
    import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
    import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
    import cariaracomp from '@/components/app/customcomp/cariaracomp'
    import analizcomp from '@/components/app/bilet/partpage/analizcomp'
    import loadingcomp from "@/components/app/customcomp/loadingcomp"
    import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp'
    import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
    
    export default {
        data() {
            return {
                rowsPerPageItems: [4, 8, 12],
      pagination: {
        rowsPerPage: 4
      },
      kategoriler:[],
      urungruplari:[],
      itemsfiyatalt:[

      {
            AltSinif: 'S1',
        Hotel:'3*',
        HotelKategori:'3 Yıldız',
        Pax:'0',
        Yfiyat:'100',
        Cfiyat:'50',
PB:'EUR',
Aktif:'Evet',
        
        },
        {
            AltSinif: 'S2',
        Hotel:'2*',
        HotelKategori:'2 Yıldız',
        Pax:'0',
        Yfiyat:'80',
        Cfiyat:'40',
PB:'EUR',
Aktif:'Evet',
        
        },
      ],
      headersfiyatalt: [
        {
            text: 'Alt Sınıf',
            value: 'AltSinif'
          },
          {
            text: 'Hotel',
            value: 'Hotel'
          },
          {
            text: 'Otel Kategori',
            value: 'HotelKategori'
          },
        
          {
            text: 'Pax',
            value: 'Pax'
          },
          {
            text: 'Yetiskin Fiyat',
            value: 'Yfiyat'
          },
          {
            text: 'Çocuk Fiyat',
            value: 'Cfiyat'
          },
          {
            text: 'PB',
            value: 'PB'
          },
          {
            text: 'Aktif',
            value: 'Aktif'
          },
        ],
      headersfiyatgrup: [{
            text: 'Grup Adı',
            value: 'GrupAdi'
          },
        

        ],
        itemsfiyatgrup:[
        {
            GrupAdi: 'Standart',
        
        
        },
        {
            GrupAdi: 'Pahalı',
         
        
        },
        ],
                PB:"TRY",
                headers:[
                    {
                        text:"Kod"
                    }
                ],
                tumsirketler:false,
                currentCheck:{},
                sablonSelectedItem:{
                    design:[]
                },
                sablonData:null,
                itemsSablon:[],
                itemsSablonSelected:[],
                counter: 0,
                loadingvmodel: false,
                videodialog: false,
                sayfayetki: {
                    Screen: true,
                    Update: true,
                    Save: true,
                    Delete: true,
                    Status: true,
                    Message: null,
                    islem: 0,
                },
    
                prevRoute: null,
    
                mukellefScroll: false,
                hesapgurubu: [],
                dialogfiltre: false,
                cokluposta: false,
                postaitems: [],
                valid: true,
                tabcontrol3: 0,
                drawer: null,
                baslik: '',
                e1: 0,
                Code: '',
                e2: true,
                yok: false,
                statecari: [],
                search: '',
                search1: '',
                loading: false,
               
             
               
    
               items: [
        {
          name: '12.09.2024',
          calories: 'Uçuş',
          fat: 'Otel',
          carbs: 'Tur',
          protein: 'Transfer',
        
        },
        {
          name: '13.09.2024',
          calories: 'Uçuş',
          fat: 'Otel',
          carbs: 'Tur',
          protein: 'Transfer',
        
        },
        {
          name: '14.09.2024',
          calories: 'Uçuş',
          fat: 'Otel',
          carbs: '',
          protein: '',
        
        },
        {
          name: '15.09.2024',
          calories: 'Uçuş',
          fat: 'Otel',
          carbs: 'Tur',
          protein: 'Dönüş',
        
        },
      
       
      ],
               
    
               
    
                dictionary: {
                    custom: {
                        carikod: {
                            required: () => this.$t('This-space-cannot-left-blank'),
                        },
                        unvan: {
                            required: () => this.$t('This-space-cannot-left-blank'),
                        },
    
                    }
                },
    
                text1:null,

                kaydetbuton: false,
                turKategoriID:null,
                turUrunGrupID:null,
                turAdi:null,
                turKodu:null,
                turGece:null,
                turGunduz:null,
                turAktif:null,
                turKontenjan:null,
                turId:0,
                turNotlar:null,
                isUpdate:false
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from.path
            })
        },
    
        mounted() {
            this.$validator.localize('en', this.dictionary)
            if (this.$route.query.id >0){
              this.isUpdate=true;
            }
       
          this.getkategoriler();
          this.geturungruplari();

          if (this.isUpdate)
          {
            this.turId=this.$route.query.id;
            this.MasterTurLoad();
          }
        },
        methods: {
          MasterTurLoad() {
      //Örnek Request
      let params = {
        Id: this.turId,
        tumSirketler: false,
        sayfaAdi: null,
      };
      tool.http_post(this, "MasterTurLoad", params).then(
        (response) => {
          if (response.body.Status == true) {
           this.turAdi=response.body.data.TurAdi;
           this.turKodu=response.body.data.TurKodu;
           this.turNotlar=response.body.data.Notlar;
           this.turGece=response.body.data.Gece;
           this.turGunduz=response.body.data.Gunduz;
           this.turAktif=response.body.data.Aktif;
           this.turKategoriID=response.body.data.Kategori.id;
           this.turUrunGrupID=response.body.data.UrunGrubu.id;
           this.turKontenjan=response.body.data.Kontenjan;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );
    },

       kaydet()
       {
       
        let params = {
        TurKodu: this.turKodu,
        TurAdi: this.turAdi,
        Notlar: this.turNotlar,
        Gece: this.turGece,
        Gunduz: this.turGunduz,
        Aktif: this.turAktif,
        KategoriId: this.turkategoriID,
        UrunGrubuId: this.tururunGrupID,
        Kontenjan: this.turKontenjan,
      };
      tool.http_post(this, "MasterTurInsert", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.text1 = 'Kayıt Eklendi';
            this.snackbar = true;
           
            var url = '#/pakettur/masterpaket';
            setTimeout(() => {  window.open(url, '_self') }, 1000)
           
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );

       },
            HataYonetimi(response, request, baslik) {
                this.mukellefScroll = false
                if (response.status === 500) {
                    //Internal Server Error
                    this.$refs.hatadialog.open(response, request, baslik);
                } else {
                    this.text1 = "Service Unavailable -" + baslik;
                    this.snackbar = true;
                }
            },
          
            getparabirimi() {
                return helpers.getparabirimi()
            },
            getkategoriler()
            {
              let params = {
        TanitimTip: 9,
      };

      tool.http_post(this, "GenelTipTanitimList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.kategoriler = response.body.data;
            console.log(response.body.data);
          } else {
            this.text1 = response.body.ErrorList[0];

            this.snackbar = true;
          }
        },

        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
            },
            geturungruplari()
            {
              let params = {
        TanitimTip: 10,
      };

      tool.http_post(this, "GenelTipTanitimList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.urungruplari = response.body.data;
            console.log(response.body.data);
          } else {
            this.text1 = response.body.ErrorList[0];

            this.snackbar = true;
          }
        },

        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
            },
          
            getDateNow: getDateNow,
           
        },
        beforeMount: beforeMount,
        components: {
            'parainput': parainput,
            yuzdeinput,
            tarihim,
            yetkidialog,
            hatadialog,
            cariaracomp,
            analizcomp,
            loadingcomp,
            muhasebekoducomp,
            snackbarcomp
        },
        watch: {
          
        }
    }
    
   
    
    function beforeMount() {
    
    }
    
    function getDateNow() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
    
        if (dd < 10) {
            dd = '0' + dd
        }
    
        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd
        return today
    }
    
   
    </script>
    
    <style>
    </style>
    